import { CommonService, RepairOrderQuoteStatusSubmitModel } from 'api-new/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type CommonRepairOrderQuoteStatusInput = {
  requestBody?: RepairOrderQuoteStatusSubmitModel;
};

export const useCommonRepairOrderQuoteStatusMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CommonService.postCommonRepairOrderQuoteStatus>>,
      QueryError,
      CommonRepairOrderQuoteStatusInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ requestBody }: CommonRepairOrderQuoteStatusInput) => {
      return CommonService.postCommonRepairOrderQuoteStatus(requestBody);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully updated!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
